import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';

function ViewEvaluationForm() {
    const [forms, setForms] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectedForm, setSelectedForm] = useState(null);

    useEffect(() => {
        axios.get('https://api.eazyworldehsengineering.com/api/eval_form')
            .then(response => setForms(response.data.forms))
            .catch(error => console.error('Error fetching forms:', error));
    }, []);

    const getValueFromFields = (label) => {
        const field = selectedForm?.fields.find(f => f.label === label);
        return field ? field.value : '';
    };

    const handleView = (form) => {
        setSelectedForm(form);
        window.$('#viewModal').modal('show');
    };

    const handlePrint = () => {
        const printContent = document.getElementById('modal-content-to-print');
        if (!printContent) return;

        const printWindow = window.open('', '', 'height=842,width=595');
        if (printWindow) {
            printWindow.document.write(`
                <html>
                <head>
                    <title>Print Evaluation Form</title>
                    <style>
                        @page { size: A4 portrait; margin: 10mm; }
                        body { font-family: Arial, sans-serif; font-size: 11px; margin: 0; padding: 0; }
                        .row { display: flex; flex-wrap: wrap; }
                        table { width: 100%; border-collapse: collapse; margin-top: 6px; font-size: 10px; }
                        table, th, td { border: 1px solid #000; padding: 4px; text-align: left; }
                        .text-center { text-align: center; }
                        .footer-section { margin-top: 20px; text-align: center; font-size: 10px; }
                        h3, h4, p { margin: 4px 0; }
                        img { height: 60px; }
                    </style>
                </head>
                <body>
                    ${printContent.innerHTML}
                </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }
    };

    const filteredForms = forms.filter(item =>
        item.fields.some(f =>
            ['Form Title', 'Operator Name', 'Evaluation Date'].includes(f.label) &&
            f.value.toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            width: '80px',
            sortable: false,
            style: { fontWeight: '500' }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Form Title</span>,
            selector: row => row.fields.find(f => f.label === 'Form Title')?.value,
            sortable: true,
            wrap: true,
            style: { fontWeight: '500' }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Operator</span>,
            selector: row => row.fields.find(f => f.label === 'Operator Name')?.value,
            sortable: true,
            style: { fontWeight: '500' }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Evaluation Date</span>,
            selector: row => row.fields.find(f => f.label === 'Evaluation Date')?.value,
            sortable: true,
            style: { fontWeight: '500' }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    <button onClick={() => handleView(row)} className="btn btn-info btn-sm mr-1"><i className="fa fa-eye"></i></button>
                    <button onClick={() => { setSelectedForm(row); handlePrint(); }} className="btn btn-primary btn-sm"><i className="fa fa-print"></i></button>
                </div>
            ),
            width: '150px'
        }
    ];

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">View Evaluation</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">View Evaluation</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header"><h3 className="card-title">Evaluation Forms</h3></div>
                <div className="card-body">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className="form-control mb-3"
                    />
                    <DataTable
                        columns={columns}
                        data={filteredForms}
                        pagination
                        paginationPerPage={100}
                        paginationRowsPerPageOptions={[100, 200, 300]}
                    />
                </div>
            </div>

            {/* View Modal */}
            <div className="modal fade" id="viewModal" tabIndex="-1" role="dialog" aria-labelledby="viewModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header bg-info">
                            <h5 className="modal-title">Form Details</h5>
                            <button type="button" className="close" data-dismiss="modal"><span>&times;</span></button>
                        </div>
                        <div className="modal-body" id="modal-content-to-print">
                            {selectedForm ? (
                                <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', padding: '20px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ width: '100px' }}>
                                            <img src="/dist/img/eazylogo.png" alt="Logo" style={{ height: '60px' }} />
                                        </div>
                                        <div style={{ flexGrow: 1, textAlign: 'center' }}>
                                            <h3 style={{ margin: 0 }}>EAZYWORLD EHS ENGINEERING PRIVATE LIMITED</h3>
                                            <p style={{ margin: 0 }}>ISO 9001-2015, 10002-20186, 45001-2018 CERTIFIED COMPANY</p>
                                            <h4 style={{ marginTop: '10px', textDecoration: 'underline' }}>{getValueFromFields('Form Title')}</h4>
                                        </div>
                                    </div>
                                    <table><tbody>
                                        <tr><td>Operator Name:</td><td>{getValueFromFields('Operator Name')}</td><td>Training Date:</td><td>{getValueFromFields('Training Date')}</td></tr>
                                        <tr><td>Evaluator Name:</td><td>{getValueFromFields('Evaluator Name')}</td><td>Evaluation Date:</td><td>{getValueFromFields('Evaluation Date')}</td></tr>
                                        <tr><td>Crane Model / Capacity:</td><td>{getValueFromFields('Crane Model / Capacity')}</td><td>Crane Location:</td><td>{getValueFromFields('Crane Location')}</td></tr>
                                    </tbody></table>
                                    <table><thead><tr style={{ background: '#eee' }}><th>Step</th><th>Evaluation</th><th>Score</th><th>Pass</th><th>Fail</th></tr></thead><tbody>
                                        {selectedForm.questions.map((q, i) => (
                                            <tr key={i}><td>{q.step}</td><td>{q.evaluation}</td><td>{q.score}</td><td style={{ textAlign: 'center' }}>{q.pass ? '✔️' : ''}</td><td style={{ textAlign: 'center' }}>{q.fail ? '❌' : ''}</td></tr>
                                        ))}
                                    </tbody></table>
                                    <div style={{ marginTop: '20px' }}><strong>{selectedForm.observation_label || 'OBSERVATION AND ENGINEER COMMENTS:'}</strong>
                                        <div style={{ border: '1px solid #000', minHeight: '40px', marginTop: '5px', padding: '5px' }}>{selectedForm.observation_comments}</div></div>
                                    <table style={{ marginTop: '10px' }}><thead style={{ backgroundColor: '#f0f0f0' }}><tr><th style={{ width: '50%', textAlign: 'center' }}>Operator Signature</th><th style={{ width: '50%', textAlign: 'center' }}>EWE-Engineer Signature</th></tr></thead><tbody><tr /><td style={{ height: '30px' }}></td><td style={{ height: '30px' }}></td><tr><th style={{ textAlign: 'center' }}>Safety In charge<br />Name & Signature</th><th style={{ textAlign: 'center' }}>Client Coordinator<br />Name & Signature</th></tr><tr><td style={{ height: '30px' }}></td><td style={{ height: '30px' }}></td></tr></tbody></table>
                                    <div style={{ marginTop: '20px' }}><strong>{selectedForm.office_use_label || 'EAZYWORLD OFFICE USE:'}</strong>
                                        <div style={{ border: '1px solid #000', minHeight: '60px', marginTop: '5px', padding: '5px' }}>{selectedForm.office_use}</div></div>
                                    <div style={{ marginTop: '40px', padding: '10px 0' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ width: '45%', textAlign: 'center' }}><strong>VERIFIED BY</strong><div style={{ height: '60px', marginTop: '5px' }}></div></div>
                                            <div style={{ width: '45%', textAlign: 'center' }}><strong>APPROVED BY</strong><div style={{ height: '60px', marginTop: '5px' }}></div></div>
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'center', fontSize: '12px', marginTop: '30px' }}>
                                        <p><strong>{selectedForm.certificateNumber || 'BPD/EWE-EHS/PRAC-EVAL/01/029/2122'} – Date - {selectedForm.certificateDate || '23-12-2022'} Controlled copy</strong></p>
                                        <p><strong>Approved By - Santhosh Koteeswaran</strong></p>
                                    </div>
                                </div>
                            ) : (
                                <p>Loading...</p>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewEvaluationForm;
